module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-5.1507fa60.jpg";